import { Box, Button, Stack, Typography, styled } from '@mui/material';
import bannerImage from 'assets/images/discovery_banner.png';
import { fontFamily } from 'theme/overrides/fontFamily';

export const StyledImageBox = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(5),
  position: 'relative',
  background: `
    url(${bannerImage}),  
    linear-gradient(0deg, ${theme.palette.grey[800]} 0%, ${theme.palette.grey[700]} 70.24%)
  `,
  backgroundSize: 'contain',
  backgroundPosition: 'right',
  backgroundRepeat: 'no-repeat',
  [theme.breakpoints.down('desktop')]: {
    background: `linear-gradient(0deg, ${theme.palette.grey[800]} 0%, ${theme.palette.grey[700]} 70.24%)`,
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3),
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 32,
  lineHeight: '48px',
  marginTop: theme.spacing(2),
}));

export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  maxWidth: theme.spacing(66),
  fontFamily: fontFamily.roboto,
  fontWeight: 400,
  fontSize: 16,
  lineHeight: '24px',
  width: theme.spacing(40),
  [theme.breakpoints.down('lg')]: {
    width: theme.spacing(36),
  },
  [theme.breakpoints.down('desktop')]: {
    width: 'unset',
  },
}));

export const StyledCTAContainer = styled(Stack)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  flexDirection: 'row',
  gap: theme.spacing(5),
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    gap: 'unset',
  },
}));

export const StyledCTAButton = styled(Button)(({ theme }) => ({
  width: 'fit-content',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
